import React from "react";

export const FooterPreview = ({ footer }) => {
  return <p>{footer}</p>;
};

